import { OrgDashboardApiListing } from 'modules/orgDashboard/api/types/OrgDashboardApiListing';
import { OrgDashboardApiListingApplicationAdminNotification } from 'modules/orgDashboard/api/types/OrgDashboardApiListingApplicationAdminNotification';
import { OrgDashboardApiOrg } from 'modules/orgDashboard/api/types/OrgDashboardApiOrg';
import {
  StaffApiListing as StaffListing,
  StaffApiOrg as StaffOrg,
} from 'modules/staff/api/orgs';
// eslint-disable-next-line import/no-namespace
import * as localStorage from 'utils/localStorage';

export const getDefaultApplyAckText = (
  org: OrgDashboardApiOrg | StaffOrg,
  listing?: OrgDashboardApiListing | StaffListing,
) => {
  const locale = (listing && listing.locale) || org.locale;
  const orgName: string =
    // TODO: Fix this the next time the file is edited.
    // @ts-expect-error TS(2339): Property 'hasOrgNameOverride' does not exist on ty... Remove this comment to see the full error message
    // eslint-disable-next-line no-nested-ternary
    listing && listing.hasOrgNameOverride && listing.orgNameOverride
      ? // @ts-expect-error TS(2339): Property 'orgNameOverride' does not exist on type ... Remove this comment to see the full error message
        listing.orgNameOverride
      : org.name
      ? org.name
      : '';
  const showOrgName =
    (listing && !listing.isPostedAnonymously && orgName) || false;
  return {
    en: `<p>Your resume and application materials have been successfully submitted ${
      showOrgName ? `to ${orgName} ` : ''
    }for the listing below.</p><p>Best Regards,</p><p>The Idealist Community Support Team</p>`,
    es: `<p>Tu currículum y otros materiales para tu postulación se han enviado correctamente ${
      showOrgName ? `a ${orgName} ` : ''
    }para esta oportunidad.</p><p>Suerte,</p><p>El Equipo de Idealist en Español</p>`,
    pt: `<p>O seu currículo e material de inscrição foram submetidos com sucesso ${
      showOrgName ? `para ${orgName} ` : ''
    }para o anúncio abaixo.</p><p>Saudações,</p><p>Equipe de Suporte à Comunidade Idealista</p>`,
  }[locale];
};
const HAS_USED_ATS = 'hasUsedAts';
export const usedAts = () => localStorage.setItem(HAS_USED_ATS, true);
export const hasUsedAts = () => localStorage.getItem(HAS_USED_ATS);

export function getMostRecentAdminNotification(
  adminNotifications?: OrgDashboardApiListingApplicationAdminNotification[],
) {
  if (!Array.isArray(adminNotifications)) {
    return null;
  }

  return adminNotifications[adminNotifications.length - 1];
}
